import { manufacturerList } from "constants/manufacturer";


const initialState = {
  manufacturerList: {},
};

const manufacturer = (state = initialState, action) => {
  switch (action.type) {
    case manufacturerList:
      return { ...state, manufacturerList: action.payload };
    default:
      return state;
  }
};

export default manufacturer;